import { render, staticRenderFns } from "./ConsultantsView.vue?vue&type=template&id=2a989a76&"
import script from "./ConsultantsView.vue?vue&type=script&lang=ts&"
export * from "./ConsultantsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports